'use strict';

define([], function () {
    return {
        repo: 'https://cdn.bdstatic.com/jwplayer/', // cdn地址改成百度云的
        SkinsIncluded: ['bce'],
        SkinsLoadable: ['beelden', 'bekle', 'five', 'glow', 'roundster', 'six', 'seven', 'stormtrooper', 'vapor'],
        dvrSeekLimit: -25
    };
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/utils/constants.js
 ** module id = 63
 ** module chunks = 0
 **/